<template>
  <!-- #1b1a1a -->
    <div class="flex flex-col bg-neutral-900 h-screen w-screen p-5" ref="mapElement">
      <div class="w-full">
        <span class="text-5xl font-extrabold text-title py-3">Wheelchair-friendly map around Pfennigparade </span>
        <!-- <span class="text-xl text-gray-100">created by Yi Zhen Chew & Ulrike Holfeld</span> -->
      </div>
      <div>
        <navigationMessage v-on:update="fromToCharged($event)" v-on:updateEnd="toChanged($event)"></navigationMessage>
      </div>
      <div class="flex pt-3 h-[80%]">
        <esriMap v-bind:from="from" v-bind:to="to"></esriMap>
        <!-- <img class="w-1/4 p-5" src="./images/legend.png" 
          height="100"
        /> -->
        <aboutVue></aboutVue>
      </div>
      
    </div>
</template>

<script>
import esriMap from "./components/esrimap.vue";
import navigationMessage from "./components/navigation";
import aboutVue from "./components/about.vue";
export default {
  name: "App",
  data: ( ) => ({
    from: 'ff', 
    to: 'ff'
  }),
  components: {
    esriMap,
    navigationMessage,
    aboutVue
  },
  methods: { 
    fromToCharged: function(event){ this.from = event},
    toChanged: function(event) {this.to = event}
  }
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: grid;
  grid-template-columns: 100vh;
  grid-auto-rows: 1fr;
  grid-gap: 1rem;
  box-sizing: border-box;
}
</style>
